module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"生活習慣スコア":"生活習慣スコア","今週":"今週","先週":"先週","体重":"体重","体脂肪率":"体脂肪率","BMI":"BMI","生活習慣レポートを見る":"生活習慣レポートを見る"},"en":{"生活習慣スコア":"Lifestyle Score","今週":"This Week","先週":"Last Week","体重":"Weight","体脂肪率":"Body Fat","BMI":"BMI","生活習慣レポートを見る":"Your Lifestyle Report"}}')
  delete Component.options._Ctor
}
